import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'form-field-label',
	standalone: true,
	imports: [NgxTolgeeModule, CommonModule],
	templateUrl: './form-field-label.component.html',
	styleUrl: './form-field-label.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldLabelComponent {
	labelTranslateKey = input<string>();
	bold = input<boolean>(true);
	asterisk = input<boolean>(false);
}
